import { useParams } from 'react-router';

export const useStrictParams = <T extends {}>() => {
  return useParams() as T;
};
